// extracted by mini-css-extract-plugin
export default {"endsIn":"OfferTimer_endsIn__ZPswd","hoursLeft":"OfferTimer_hoursLeft__js494"};